export const currencyFormat = (num: number) => {
  return (+num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export const exchangeFormat = (num: number) => {
  return Number((+num).toFixed(0))
}
